import { render, staticRenderFns } from "./carrer-question.vue?vue&type=template&id=4b724cf6&"
import script from "./carrer-question.vue?vue&type=script&lang=js&"
export * from "./carrer-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports